module.exports = __webpack_public_path__ + "img/intro-sec02-bt-bg.998c492e.png";